import script from "./ShapeStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeStylePanel.vue?vue&type=style&index=0&id=0674f2cf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0674f2cf"]])

export default __exports__